import gpo from './gpo';

const menuItems = {
  items: [gpo]
};

export default menuItems;
